import {createContext} from 'react';

import {TableVariant} from './types/TableVariant';

export interface TableContextType {
  variant: TableVariant;
}

export const Context = createContext<TableContextType>({variant: 'bordered'});
